import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import pkg from '../package.json'

Vue.use(Router)

const { endpoint } = pkg.config
// const endpoint = '/foxtrot/university-of-suffolk/staging/v3d/'
// const endpoint = 'http://localhost:8081/'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/:category_id',
    component: () => import(/* WebpackChunkName: "categories" */ './views/Categories.vue'),
    children: [
      {
        path: '/:category_id',
        name: 'category',
        component: () => import(/* WebpackChunkName: "category" */ './views/Category.vue')
      }
    ]
  },
  {
    path: '/:category_id/:media_id',
    component: () => import(/* WebpackChunkName: "contents" */ './views/Contents.vue'),
    children: [
      {
        path: '/:category_id/:media_id',
        name: 'content',
        meta: { header: true },
        component: () => import(/* WebpackChunkName: "content" */ './views/Content.vue'),
        children: [
          {
            path: '/:category_id/:media_id/watch',
            name: 'video',
            component: () => import(/* WebpackChunkName: "media" */ './views/Media.vue')
          },
          {
            path: '/:category_id/:media_id/view/:panorama_id',
            name: 'panorama',
            component: () => import(/* WebpackChunkName: "panorama" */ './views/Media.vue')
          }
        ]
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.state.posts.length) {
    fetch(`${endpoint}data.json`)
      .then(res => res.json())
      .then((res) => {
        store.commit({
          type: 'populate',
          posts: res,
          error: null
        })
        store.commit('route', to)

        const isMediaPath = (to.name === 'video' || to.name === 'panorama') || false
        store.commit('isMedia', isMediaPath)

        next()
        store.commit('isLoading', false)
      })
      .catch((err) => {
        store.commit({
          type: 'populate',
          error: err
        })
      })
  } else {
    store.commit('isLoading', true)
    store.commit('route', to)

    const isMediaPath = (to.name === 'video' || to.name === 'panorama') || false
    store.commit('isMedia', isMediaPath)
    next()
    store.commit('isLoading', false)
  }
})

// Router.beforeEach((to, from, next) => {
//   store.commit('isLoading', true)

//   const isMediaPath = (to.name === 'video' || to.name === 'panorama') || false
//   store.commit('route', to)
//   store.commit('isMedia', isMediaPath)

//   next()

//   store.commit('isLoading', false)
// })

export default router
